import React from 'react';

export type PublicDemoFormStatus = 'idle' | 'loading' | 'success' | 'error';

type Props = {
  status: PublicDemoFormStatus;
  successMessage: string;
  errorMessage: string;
  /** Use `light` when the form sits on a light panel so messages stay readable while `html` may still be `.dark`. */
  tone?: 'dark' | 'light';
};

/**
 * Shared success/error messaging for public demo forms (Slice 9 — exp-plan-deploy).
 */
export function DemoFormFeedback({ status, successMessage, errorMessage, tone = 'dark' }: Props) {
  const successClass = tone === 'light' ? 'text-green-700' : 'text-green-400';
  const errorClass = tone === 'light' ? 'text-red-600' : 'text-red-400';

  if (status === 'success') {
    return (
      <p className={`mt-3 text-sm ${successClass}`} role='status'>
        {successMessage}
      </p>
    );
  }
  if (status === 'error') {
    return (
      <p className={`mt-3 text-sm ${errorClass}`} role='alert'>
        {errorMessage}
      </p>
    );
  }
  return null;
}
